import e from "./ghl-ui.es1556.js";
function d(s, i) {
  var t = this.__data__, a = e(t, s);
  return a < 0 ? (++this.size, t.push([s, i])) : t[a][1] = i, this;
}
export {
  d as default
};
